import React from "react";
import { LayoutDashboard, Receipt, BrainCircuit, Zap } from "lucide-react";

const TABS = [
  { id: "overview", label: "Panoramica", icon: LayoutDashboard, testid: "tabbar-overview" },
  { id: "posizioni", label: "Posizioni", icon: Receipt, testid: "tabbar-posizioni" },
  { id: "segnali", label: "Segnali AI", icon: BrainCircuit, testid: "tabbar-segnali" },
];

export default function BottomTabBar({ active, onNavigate, onNewSignal, canTrade }) {
  return (
    <nav
      data-testid="mobile-bottom-tabbar"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#0E1422]/95 backdrop-blur-md border-t border-white/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-4">
        {TABS.map((t) => {
          const Icon = t.icon;
          const isActive = active === t.id;
          return (
            <button
              key={t.id}
              data-testid={t.testid}
              onClick={() => onNavigate(t.id)}
              className={`flex flex-col items-center justify-center gap-1 py-2.5 transition-colors ${
                isActive ? "text-amber-400" : "text-slate-400 hover:text-slate-100"
              }`}
            >
              <Icon size={20} />
              <span className="text-[10px] font-semibold">{t.label}</span>
              {isActive && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-amber-400" />}
            </button>
          );
        })}
        <button
          data-testid="tabbar-new-signal"
          onClick={canTrade ? onNewSignal : undefined}
          disabled={!canTrade}
          className="flex flex-col items-center justify-center gap-1 py-2.5 text-[#0B0E17] disabled:opacity-40"
        >
          <span className="w-10 h-10 -mt-4 rounded-full grid place-items-center bg-gradient-to-br from-amber-400 to-amber-500 shadow-[0_0_18px_rgba(245,158,11,0.5)]">
            <Zap size={20} />
          </span>
          <span className="text-[10px] font-semibold text-amber-400">Segnale</span>
        </button>
      </div>
    </nav>
  );
}
